import React from "react";
import { IoCheckmarkCircleOutline as CheckIcon } from "@react-icons/all-files/io5/IoCheckmarkCircleOutline";
import { isEmpty } from "@Utils";
import styles from "./coursedetails.module.scss";
import { ICourseDetails } from "./ICourseDetails";
import commonStyles from "../commonStyles.module.scss";
import { urlify } from "./data";
import useCourseDetail from "./useCourseDetail";

const CourseDetails = ({
    courseDetail,
    title,
}: ICourseDetails.IProps): JSX.Element | null => {
    const { data } = useCourseDetail({ courseDetail });

    if (isEmpty(data)) return null;
    return (
        <div className={commonStyles.detailsSection}>
            <div className={commonStyles.detailsSectionTitle}>{title}</div>
            <div className={commonStyles.detailsSectionBody}>
                {data?.map((d: string, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={d + index} className={styles.listItemContainer}>
                        <CheckIcon className={styles.icon} />
                        <div
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: urlify(d) }}
                            // eslint-disable-next-line react/no-array-index-key
                            key={d + index}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CourseDetails;
